<template>
  <div class="line-broadcast-tag">
    <p>{{ tagText }}</p>
  </div>
</template>
<script>
export default {
  name: 'LineBroadcastTag',
  props: {
    tagText: {
      type: String,
      require: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.line-broadcast-tag {
  background-color: #f5f6fa;
  border-radius: 8px;
  padding: 2px 12px;
  width: fit-content;
  p {
    margin: 0;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #4b5178;
    user-select: none;
  }
}
</style>
